import React from 'react';
import StreamCard from './StreamCard';
import '../styles/StreamsList.css';

const StreamsList = ({ streams, toggleFavorite, viewMode, onStreamClick, slideDirection, isFirstLoad, selectedDate, isArchiveMode }) => {
  // ストリームがない場合のメッセージ
  if (streams.length === 0) {
    return (
      <div className={`no-streams ${slideDirection || ''}`}>
        <p>ただいま予約投稿はありません。<br />最新情報は X / YouTube / ツイキャス もご確認ください。</p>
      </div>
    );
  }

  // ライブ配信を優先表示、同じステータスの場合は元の順番を維持
  const sortedStreams = [...streams].sort((a, b) => {
    // ライブ配信を優先
    if (a.status === 'live' && b.status !== 'live') return -1;
    if (a.status !== 'live' && b.status === 'live') return 1;
    
    // 同じステータスの場合は元の順番を維持
    return 0;
  });

  return (
    <div className={`streams-list ${viewMode === 'grid' ? 'grid-view' : 'list-view'} ${slideDirection || ''}`}>
      {sortedStreams.map((stream, index) => (
        <StreamCard 
          key={stream.id} 
          stream={stream} 
          index={index}
          toggleFavorite={toggleFavorite} 
          onStreamClick={onStreamClick}
          isFirstLoad={isFirstLoad}
          isArchiveMode={isArchiveMode}
        />
      ))}
    </div>
  );
};

export default React.memo(StreamsList);
